module.exports = __webpack_public_path__ + "media/lucky_slide.08fa7b0c.mp3";